import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { AlertTriangle, X, Mail, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { toast } from "sonner";

export default function WarrantyBanner() {
  const [items, setItems] = useState([]);
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    api.get("/warranty/expiring", { params: { days: 7 } })
      .then((r) => setItems(r.data))
      .catch(() => setItems([]));
  }, []);

  const sendReminders = async () => {
    setSending(true);
    try {
      const { data } = await api.post("/warranty/notify", null, { params: { days: 7, notify_customers: true } });
      toast.success(`E-postalar gönderildi (özet: 1, müşteri: ${data.sent_to_customers})`);
    } catch {
      toast.error("E-posta gönderilemedi");
    } finally {
      setSending(false);
    }
  };

  if (dismissed || items.length === 0) return null;

  return (
    <div
      className="border border-orange-500/30 bg-orange-500/10 rounded-xl px-4 py-3 flex items-start gap-3"
      data-testid="warranty-banner"
    >
      <div className="h-8 w-8 rounded-full bg-orange-500/20 flex items-center justify-center flex-shrink-0">
        <AlertTriangle className="h-4 w-4 text-orange-600 dark:text-orange-400" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium text-orange-900 dark:text-orange-200">
          {items.length} müşterinin garantisi 7 gün içinde doluyor
        </div>
        <div className="text-xs text-orange-800/80 dark:text-orange-300/80 mt-1 truncate">
          {items.slice(0, 3).map((c) => (
            <Link key={c.id} to={`/customers/${c.id}`} className="mr-3 underline underline-offset-2 hover:text-orange-900 dark:hover:text-orange-100">
              {c.first_name} {c.last_name} ({c.days_left}g)
            </Link>
          ))}
          {items.length > 3 && <span>+{items.length - 3} daha</span>}
        </div>
      </div>
      <Button
        size="sm"
        variant="outline"
        onClick={sendReminders}
        disabled={sending}
        data-testid="send-warranty-reminders"
        className="border-orange-500/40 bg-orange-500/20 hover:bg-orange-500/30 text-orange-900 dark:text-orange-100 rounded-full flex-shrink-0"
      >
        {sending ? <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" /> : <Mail className="h-3.5 w-3.5 mr-1" />}
        E-posta Gönder
      </Button>
      <button
        onClick={() => setDismissed(true)}
        className="text-orange-700 dark:text-orange-300 hover:text-orange-900 dark:hover:text-orange-100 flex-shrink-0"
        data-testid="warranty-banner-close"
        aria-label="Kapat"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}

